<template>
  <div class="container-fluid mycontainer-fluid content">
    <div class="content-progres"></div>
    <a @click="returnToCalendar">&#x025c2; Вернуться к документам</a>
    <br />
    <br />
    <template v-if="isViewTargets() === true">
      <h4>Цели проекта</h4>
      <p style="padding-bottom: 10px;">
        <em
          >Пожалуйста, заполните все подразделы календарного плана. На основании
          указанной информации будут сформированы приложения к договору
          займа.</em
        >
      </p>

      <div class="form-group">
        <textarea
          class="form-control"
          maxlength="1000"
          rows="4"
          v-model="project.UF_TARGETS"
          :disabled="
            isAcceptPlan || project.projectDisabled || isPlanCoordinated
          "
        >
        </textarea>
      </div>
      <button
        v-if="!isAcceptPlan"
        type="button"
        @click="saveTargetProject()"
        :disabled="
          !project.UF_TARGETS ||
            project.UF_IS_BLOCK == 1 ||
            isPlanCoordinated
        "
        class="btn btn-success"
      >
        Сохранить
      </button>
      <br />
      <hr />
    </template>

    <template v-if="isViewTehnologicalLines() === true">
      <h4>Производственные участки и технологические линии</h4>
      <TechnologicalLines
        :editable="
          !isAcceptPlan &&
            !project.projectDisabled &&
            !project.UF_IS_BLOCK &&
            !isPlanCoordinated
        "
        :project="project"
      ></TechnologicalLines>
      <hr />
    </template>

    <template v-if="isViewLocationProducts() === true">
      <h4>Место реализации проекта</h4>
      <LocationProducts
        :editable="
          !isAcceptPlan &&
            !project.projectDisabled &&
            !project.UF_IS_BLOCK &&
            !isPlanCoordinated
        "
        :project="project"
      ></LocationProducts>
      <hr />
    </template>

    <template v-if="isViewKP() === true">
      <h4>
        Задачи проекта и Календарный план
        <VDropdown
          tag="span"
          trigger="click"
          placement="bottom"
          popperClass="custom-popper"
          v-if="!isAllowLongStagesKp"
          :distance="25"
          style="display: inline"
        >
          <a class="icon-help icon-help-top" />
          <template #popper>
            <div class="custom-popper-content">
              Продолжительность этапа календарного плана не может превышать 4
              квартала. В случае, если этап длится более, чем 4 квартала, его
              следует разбить на подэтапы.
            </div>
          </template>
        </VDropdown>
      </h4>
      <p style="padding-bottom: 12px;">
        <em>Пожалуйста, укажите продолжительность каждого этапа</em>
      </p>
      <table class="c-indicator c-indicator-w-100 scroll-table">
        <thead>
          <tr>
            <th class="tab-wid-80" style="min-width: 120px" rowspan="2">№</th>
            <th rowspan="2">Название этапа</th>
            <th rowspan="2" v-if="cptMode">Дополнительная<br> информация по этапу</th>
            <th rowspan="2" v-if="cptMode">Документы,<br> отражающие результат</th>
            <th rowspan="2">
              Вид затрат <br />
              Сметы (в части средств Займа)
            </th>
            <th rowspan="2" v-if="!cptMode">
              Наименование отчетного документа, отражающего результат
            </th>
            <th
              style="text-align: center"
              v-for="year in calendarYears"
              colspan="4"
            >
              {{ year }}
            </th>
            <th rowspan="2">&nbsp;</th>
          </tr>
          <tr>
            <fragment v-for="year in calendarYears" :key="year">
              <th :at="year" style="font-size:12px;">I кв.</th>
              <th style="font-size:12px;">II кв.</th>
              <th style="font-size:12px;">III кв.</th>
              <th style="font-size:12px;">IV кв.</th>
            </fragment>
          </tr>
        </thead>
        <CalendarRow
          :p-hide="item.IS_HIDE"
          v-show="!item.IS_HIDE"
          v-for="(item, index) in calendarItems.PLAN"
          :key="index"
          :item="calendarItems.PLAN[index]"
          :parent-items="calendarItems.PLAN"
          :items="calendarItems.PLAN[index].CHILD"
          :idx="parseInt(index) + 1"
          :pr="''"
          :lvl="1"
          :index-tree="index"
          :calendar-years="calendarYears"
          :editable="isPlanEditable && !isPlanCoordinated"
          :save-errors="saveErrors"
          :project="project"
          :cpt-mode="cptMode"
        ></CalendarRow>
      </table>
      <br /><br />
      <button
        v-if="isPlanEditable && !project.UF_IS_BLOCK && !isPlanCoordinated"
        class="btn btn-info btn-style-big"
        type="button"
        @click="addItem"
      >
        Добавить этап</button
      >&nbsp;&nbsp;
      <button
        v-if="isPlanEditable && !project.UF_IS_BLOCK && !isPlanCoordinated"
        class="btn btn-success"
        type="button"
        @click="saveItems"
      >
        Сохранить изменения
      </button>

      <!--<template v-if="isViewAcceptButton">
        &nbsp;&nbsp;&nbsp;
        <button
          v-if="project.UF_SETTING.IS_PLAN_ACCEPT !== 1"
          class="btn btn-success"
          style="width: 200px"
          @click="changeAcceptCalendarPlan(1)"
        >
          Акцептовать КП
        </button>
        <button
          v-else
          class="btn btn-danger"
          style="width: 200px"
          @click="changeAcceptCalendarPlan(0)"
        >
          Вернуть КП в работу
        </button>
      </template>-->

      <template
        v-if="
          isViewAllowLongStagesButton && isPlanEditable && !isPlanCoordinated
        "
      >
        &nbsp;&nbsp;&nbsp;
        <button
          v-if="!isAllowLongStagesKp && !project.UF_IS_BLOCK"
          class="btn btn-warning btn-style-big"
          style="width: 240px;"
          @click="saveEditSettingField('UF_IS_ALLOW_LONG_STAGES_KP', 1)"
        >
          Разрешить длинные этапы
        </button>
        <button
          v-else-if="!project.UF_IS_BLOCK"
          class="btn btn-danger btn-style-big"
          style="width: 240px;"
          @click="saveEditSettingField('UF_IS_ALLOW_LONG_STAGES_KP', 0)"
        >
          Длина этапов не ограничена
        </button>
      </template>
    </template>

    <template v-if="isViewProductsProject() === true">
      <hr />
      <h4>Продукция проекта</h4>

      <ProjectOkpdProducts
        v-if="
          project.UF_SETTING &&
            project.UF_SETTING.IS_VIEW_NEW_INFORMATION_PROJECT
        "
        :readonly="true"
      ></ProjectOkpdProducts>

      <template v-else>
        <ProjectProductsV3
          v-if="
            getProgramCode() == 'lekarstva' &&
              project.UF_SETTING &&
              (project.UF_SETTING.VERSION_PRODUCT_LIST >= 3 || project.UF_SETTING.VERSION_MARKER_PRODUCTS >= 3)
          "
          :editable="
            !isAcceptPlan &&
              !project.projectDisabled &&
              !project.UF_IS_BLOCK &&
              !isPlanCoordinated
          "
          :project="project"
          :programmCode="getProgramCode()"
        ></ProjectProductsV3>

        <ProjectProducts
          v-else
          :editable="
            !isAcceptPlan &&
              !project.projectDisabled &&
              !project.UF_IS_BLOCK &&
              !isPlanCoordinated
          "
          :project="project"
          :programmCode="getProgramCode()"
        ></ProjectProducts>
      </template>
      <hr />
    </template>
  </div>
</template>

<script>
import CalendarRow from "@/components/project/documents/CalendarRow";
import TechnologicalLines from "@/components/project/form/partial/TechnologicalLines";
import LocationProducts from "@/components/project/form/partial/LocationProducts";
import ProjectProducts from "@/components/project/form/partial/ProjectProducts";
import ProjectProductsV3 from "@/components/project/form/partial/ProjectProductsV3";
import ProjectOkpdProducts from "@/components/project/form/partial/ProjectOkpdProducts";
import { ProjectsService } from "@/common/api.service";
import { FETCH_DIRECTORY, FETCH_PROJECT } from "@/store/actions.type";
import { mapGetters } from "vuex";
//import { SET_IS_VIEW_ALL_EXPERTISE } from "../../../store/actions.type";

export default {
  name: "Calendar",
  components: {
    CalendarRow,
    TechnologicalLines,
    LocationProducts,
    ProjectProducts,
    ProjectProductsV3,
    ProjectOkpdProducts
  },
  data() {
    return {
      isPlanEditable: false,
      isAcceptPlan: false,
      saveErrors: [],
      tosterErrors: [],
      isViewAcceptButton: false,
      isViewAllowLongStagesButton: false
    };
  },
  async created() {
    await this.$store
      .dispatch(FETCH_DIRECTORY, ["plan_istochnik_sp"])
      .then(() => {}, this);
    await this.$store.dispatch(FETCH_PROJECT, this.$route.params.id);
    await ProjectsService.getRulesChangeStatusUser(
      this.project.UF_STATUS_ID
    ).then(({ data }) => {
      this.isPlanEditable = data.IS_EDIT_PLAN;
    }, this);

    //если акцептован, не правим
    if (this.project.UF_SETTING.IS_PLAN_ACCEPT === 1) {
      this.isPlanEditable = false;
      this.isAcceptPlan = true;
    }

    await this.$store
      .dispatch(FETCH_DIRECTORY, ["program_fin_support"])
      .then(async () => {}, this);
    await this.$store
      .dispatch(FETCH_DIRECTORY, ["sp_project_products_list"])
      .then(async () => {}, this);
  },
  computed: {
    cptMode() {
      // project.SETTING_TABLE может ещё не подгрузиться (FETCH_PROJECT
      // резолвится позже показа календаря) — не роняем рендер
      const st = this.project && this.project.SETTING_TABLE;
      return !!(st && st.data && st.data.UF_CPT_MODE == 1);
    },
    // Длинные этапы КП разрешены? Безопасно к незагруженному project
    isAllowLongStagesKp() {
      const st = this.project && this.project.SETTING_TABLE;
      return !!(st && st.data && st.data.UF_IS_ALLOW_LONG_STAGES_KP == 1);
    },
    calendarYears() {
      let ret = [];
      for (
        let i = this.calendarItems.YEAR_SETTING.yearStart;
        i <= this.calendarItems.YEAR_SETTING.yearEnd;
        i++
      ) {
        ret.push(i);
      }

      return ret;
    },
    isPlanCoordinated() {
      const list = this.project && this.project.COORDINATIONS;
      if (!Array.isArray(list)) {
        return false;
      }
      return list.some(
        el =>
          el &&
          el.UF_TYPE_PAGE === "plan_10_01" &&
          (el.UF_IS_COORDINATION == 1 || el.UF_IS_COORDINATION === true)
      );
    },
    ...mapGetters(["calendarItems", "project", "directory", "currentUser"])
  },
  mounted() {
    if (this.currentUser.TYPE_USER === "manager") {
      ProjectsService.getManagerRoleDefaultSetting()
        .then(({ data }) => {
          this.isViewAcceptButton = parseInt(data.IS_ACCEPT_PLAN);
          this.isViewAllowLongStagesButton = parseInt(
            data.IS_ALLOW_LONG_STAGES_KP
          );
        }, this)
        .catch(err => console.log(err));
    }
  },
  methods: {
    returnToCalendar() {
      this.tosterErrors.forEach(function(err) {
        err.goAway(0);
      });
      this.$parent.hideCalendar();
    },
    addItem() {
      this.calendarItems.PLAN.push({
        ID: 0,
        UF_PARENT_ID: 0,
        UF_PROJECT_ID: this.project.ID,
        UF_NAME: "",
        UF_DOCUMENT: "",
        YEAR_DATA: null,
        IS_HIDE: false,
        UF_LEVEL: 1,
        UF_ISTOCHNIK_ID: [],
        UF_POSITION: this.calendarItems.PLAN.length,
        CHILD: []
      });
    },
    saveItems() {
      this.tosterErrors.forEach(function(err) {
        err.goAway(0);
      });
      function removeItems(items) {
        let plan = [];
        items.forEach(function(item) {
          if (!item.IS_HIDE) {
            if (item.CHILD && item.CHILD.length > 0) {
              item.CHILD = removeItems(item.CHILD);
            }
            plan.push(item);
          }
        });
        return plan;
      }

      let plan = removeItems(this.calendarItems.PLAN);
      console.log(plan);
      ProjectsService.savePlan(this.$parent.project.ID, plan).then(
        ({ data }) => {
          if (data.error) {
            this.saveErrors = data.errorArr;
            this.saveErrors.forEach(function(err) {
              this.tosterErrors[this.tosterErrors.length] = this.$toasted.show(
                err.TEXT,
                {
                  theme: "bubble",
                  position: "bottom-right",
                  duration: null,
                  action: [
                    {
                      text: "Закрыть",
                      onClick: (e, toastObject) => {
                        toastObject.goAway(0);
                      }
                    },
                    {
                      text: "Закрыть все",
                      onClick: () => {
                        this.tosterErrors.forEach(function(err) {
                          err.goAway(0);
                        });
                      }
                    }
                  ]
                }
              );
            }, this);

            return;
          }
          this.$toasted.show("Календарь сохранен", {
            theme: "green",
            position: "bottom-right",
            duration: 3000
          });
          this.$parent.loadCalendar();
        },
        this
      );
    },
    getProgramCode() {
      let t = this.directory.program_fin_support.filter(
        c => c.ID === this.project.UF_SUPPORT_PROG_ID
      );
      if (t.length > 0) {
        return t[0].CODE;
      }
      return "";
    },
    isViewTargets() {
      return this.getProgramCode() === "lekarstva" ||
        this.getProgramCode() === "lizing"
        ? false
        : true;
    },
    isViewTehnologicalLines() {
      return this.getProgramCode() === "lekarstva" ||
        this.getProgramCode() === "improving_ecology"
        ? true
        : false;
    },
    isViewKP() {
      if (this.calendarItems.httpCode === 403){
        this.$router.push({ name: "ForbiddenPage403" });
      }
      return this.getProgramCode() === "epidemiological_control" ||
        this.getProgramCode() === "component_and_resource_base" ||
        this.getProgramCode() === "providing_mobilization_needs"
        ? false
        : true;
    },
    isViewLocationProducts() {
      return this.getProgramCode() !== "lekarstva" ? true : false;
    },
    isViewProductsProject() {
      return this.getProgramCode() !== "improving_ecology" ? true : false;
    },
    saveTargetProject() {
      ProjectsService.saveTargetProject(this.$route.params.id, {
        UF_TARGETS: this.project.UF_TARGETS
      }).then(({ data }) => {
        if (data.error) {
          data.errorArr.forEach(function(text) {
            this.$toasted.show(text.TEXT, {
              theme: "red",
              position: "bottom-right",
              duration: 3500
            });
          }, this);
          return;
        } else {
          this.$toasted.show("Цели проекта сохранены", {
            theme: "green",
            position: "bottom-right",
            duration: 3000
          });

          if (data.infoArr.length) {
            data.infoArr.forEach(function(text) {
              this.$toasted.show(text.TEXT, {
                theme: "orange",
                position: "bottom-right",
                duration: 4000
              });
            }, this);
          }
        }
      }, this);
    },
    countEnt(value, limit) {
      if (value) {
        const length = String(value).length;
        return length > limit ? 0 : limit - length;
      }
      return limit;
    },
    changeAcceptCalendarPlan(params) {
      ProjectsService.changeAcceptCalendarPlan(this.project.ID, params).then(
        ({ data }) => {
          if (data.error) {
            data.errorArr.forEach(function(text) {
              this.$toasted.show(text.TEXT, {
                theme: "red",
                position: "bottom-right",
                duration: 3500
              });
            }, this);
            return;
          } else {
            this.$toasted.show(
              "Статус акцепта календарного плана успешно изменен",
              {
                theme: "green",
                position: "bottom-right",
                duration: 3000
              }
            );

            this.isPlanEditable = params == 1 ? false : true;
            this.project.UF_SETTING.IS_PLAN_ACCEPT = params;
          }
        },
        this
      );
    },
    saveEditSettingField(nameSettingField, valueTempBoolSettingFields) {
      ProjectsService.editSettingProjectField(
        this.project.ID,
        nameSettingField,
        {
          VALUE: valueTempBoolSettingFields
        }
      ).then(({ data }) => {
        if (data.error) {
          data.errorArr.forEach(function(text) {
            this.$toasted.show(text.TEXT, {
              theme: "red",
              position: "bottom-right",
              duration: 3500
            });
          }, this);
          return;
        } else {
          let nameMessage =
            valueTempBoolSettingFields == 1
              ? "Длинные этапы разрешены"
              : "Длинные этапы запрещены";
          this.$toasted.show(nameMessage, {
            theme: "green",
            position: "bottom-right",
            duration: 3000
          });
        }

        this.showEditBoolSettingFields = false;
        this.$parent.fetchProject();
      }, this);
    }
  },
  beforeRouteLeave(to, from, next) {
    this.tosterErrors.forEach(function(err) {
      err.goAway(0);
    });
    next();
  }
};
</script>

<style scoped></style>
